import { createReducer, on } from '@ngrx/store';

import * as UserActions from './user.actions';
import { FormMode, IFormMode } from '../../types/IFormMode';
import { User } from '../../../core/domain/company/company';

export interface UserState {
  isAddModalOpen: boolean;
  isModalOpen: boolean; // general form modal
  formMode?: IFormMode;
  openedUser?: User;
}

export const initialState: UserState = {
  isAddModalOpen: false,
  isModalOpen: false,
  formMode: undefined,
  openedUser: undefined,
};

export const userReducer = createReducer(
  initialState,
  on(UserActions.openAddUserModal, (state) => ({
    ...state,
    isAddModalOpen: true,
  })),
  on(UserActions.closeAddUserModal, (state) => ({
    ...state,
    isAddModalOpen: false,
  })),

  on(UserActions.openUserModal, (state, action) => ({
    ...state,
    isModalOpen: true,
    formMode: action.mode,
    openedUser: action.user || undefined,
  })),
  on(UserActions.closeUserModal, (state) => ({
    ...state,
    isModalOpen: false,
    formMode: undefined,
    openedUser: undefined,
  }))
);
